import React, { useState, useRef, useEffect } from "react";
import type { KeyLearningsData } from "../../utils/mockProjects";

interface LearningProps {
  keyLearnings: KeyLearningsData;
}

export const KeylearningsMobile: React.FC<LearningProps> = ({
  keyLearnings,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const learningRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = learningRefs.current.findIndex(
              (ref) => ref === entry.target,
            );
            if (index !== -1) {
              setActiveIndex(index);
            }
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
      },
    );

    learningRefs.current.forEach((ref) => {
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleDotClick = (index: number) => {
    const ref = learningRefs.current[index];
    if (ref) {
      ref.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="w-full flex flex-col justify-between items-center gap-6">
      <p className="font-gilroy-bold w-full text-lg text-primary ">
        Key Learnings
      </p>

      <p className="md:text-2xl text-lg leading-[1] font-gilroy-bold">
        {keyLearnings?.heading}
      </p>

      <img src={keyLearnings?.img} alt="learning1" className="w-full" />

      <div className="w-full flex flex-col mt-6 gap-8">
        <p className="font-gilroy-bold md:text-xl text-lg">Furthermore</p>
        <div className="flex w-full gap-4 items-center">
          <div className="flex flex-col items-center ">
            {keyLearnings?.learnings?.map((_, index) => (
              <div
                key={index}
                onClick={() => handleDotClick(index)}
                className={`cursor-pointer transition-all duration-300 ${
                  activeIndex === index
                    ? "w-0.5 h-24 bg-white my-2"
                    : "min-w-2.5 min-h-2.5 max-w-2.5 max-h-2.5 rounded-full bg-white my-3"
                }`}
              />
            ))}
          </div>

          <div className="w-full h-[15vh] overflow-y-auto">
            {keyLearnings?.learnings?.map((learning, index) => (
              <div
                key={index}
                ref={(el) => {
                  learningRefs.current[index] = el;
                }}
                className={`${
                  index === keyLearnings?.learnings?.length - 1
                    ? "mb-0"
                    : "mb-16"
                }`}
              >
                <div className="flex mb-2 gap-2">
                  <div className="text-2xl font-gilroy-bold">
                    {index + 1}.
                  </div>
                  <h1 className="text-2xl font-gilroy-bold">
                    {learning.title}
                  </h1>
                </div>
                <p className="text-base font-gilroy-light">
                  {learning.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
